import Vue from 'vue'
import Vuex from 'vuex'
import attributeTable from "@/store/modules/attributeTable.js";
import toast from "@/store/modules/toast.js";
import draw from "@/store/modules/draw.js";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    attributeTable,
    toast,
    draw
  },
  state: {
    role: undefined,
    token: null,
    mobile: false,
    mustChangePassword: false,

    // TRUE si se está mostrando un mapa, FALSE en caso contrario
    mapActive: false,

    // Almacena el estado de los controles de navegación y otros elementos del mapa
    mapControls: {
      legends: { active: false },
      loadScreen: { active: false },
      navDrawer: { active: false }
    },

    // Almacena la herramienta seleccionada del mapa
    mapTools: {
      select: { active: false, action: '', data: {} },
      measures: { active: false, action: '', data: {} },
      chart: { active: false, action: '', data: {} },
      magnify: { active: false, action: '' },
      export: { active: false, action: '', format: 'image', data: null },
      layers: { active: false, action: '' },
      search: { active: false, action: '' },
      geoprocessing: { active: false, action: '', data: {} },
      basemap: { active: false, action: '' },
      shpKmzUpload: { active: false, action: '' },
      help: { active: false, action: '' },
      annotations: { active: false, action: '', data: {} },
      attributesTable: { active: false, action: '', data: {} },
      locator: { active: false, action: '' },
      draw: {active: false, action:'', data:{}}
    },

    layers: [],
    activeLayers: [],
    geoprocessings: []
  },
  getters: {
    backendurl() {
      //Acceder de la siguiente forma:
      //this.$store.getters.backendurl
      return process.env.VUE_APP_API_URL;
    },
    getPermissions(state) {
      if (state.role) {
        return state.role;
      }
      return undefined
    },
    getToken(state) {
      if (state.token) {
        return state.token;
      }
      return undefined
    },
    // TRUE si se trata de un dispositivo móvil, FALSE si es un computador
    isMobile(state) {
      return state.mobile
    },
    isMapActive(state) {
      return state.mapActive
    },
    // Entrega la herramienta del mapa seleccionada
    // Exclude 'select' — SelectTool is rendered independently in MapContainer
    // Exclude 'help' — HelpDocuments is rendered independently in ToolContainer
    getMapSelectedTool: state => {
      let result = Object.keys(state.mapTools)
        .filter(tool => tool !== 'select' && tool !== 'help' && state.mapTools[tool].active)
      return result.length > 0 ? result[0] : ''
    },
    // Entrega la herramienta que está ejecutando una acción
    getMapActionTool: state => {
      let result = Object.keys(state.mapTools).filter(tool => state.mapTools[tool].action != '')
      let result2 = result.length > 0 ? result[0] : ''
      return result2
    },
    // Entrega los atributos de una herramienta del mapa
    getMapTools: (state) => {
      return state.mapTools
    },
    // Entrega los atributos de un control de navegación del mapa
    getMapControls: (state) => {
      return state.mapControls
    },
    // Entrega las capas disponibles para el usuario del visor 
    getLayers: state => {
      return state.layers
    },
    // Entrega las capas seleccionadas para visualizarse en el mapa
    getActiveLayers: state => {
      return state.activeLayers
    },
    // Entrega los geoprocesos disponibles para el usuario del visor
    getGeoprocessings: state => {
      return state.geoprocessings
    },
    //Entrega los documentos disponibles para el usuario del visor
    getDocuments: state => {
      return state.docs
    },
  },
  mutations: {
    setPermissions(state) {
      var name = "session_public" + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          var parsed = JSON.parse(c.substring(name.length, c.length));
          state.mustChangePassword = !!parsed.must_change_password;
          var role = Object.assign({}, parsed);
          delete role.must_change_password;
          state.role = role;
          return;
        }
      }
      state.role = undefined;
      state.mustChangePassword = false;
      return;
    },
    setMustChangePassword(state, value) {
      state.mustChangePassword = !!value;
    },
    setToken(state) {
      var name = "session_token" + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          state.token = c.substring(name.length, c.length);
          return;
        }
      }
      state.token = undefined;
      return;
    },
    setIsMobile(state) {
      state.mobile = true;
      return
    },
    setIsNotMobile(state) {
      state.mobile = false;
      return
    },
    setMapActive(state, isActive) {
      state.mapActive = isActive
    },
    // Desactiva cualquier herramienta del mapa seleccionada anteriormente
    resetMapToolsSelection(state) {
      state.mapTools.select.active = false
      state.mapTools.measures.active = false
      state.mapTools.chart.active = false
      state.mapTools.magnify.active = false
      state.mapTools.layers.active = false
      state.mapTools.search.active = false
      state.mapTools.geoprocessing.active = false
      state.mapTools.export.active = false
      state.mapTools.basemap.active = false
      state.mapTools.shpKmzUpload.active = false
      state.mapTools.help.active = false
      state.mapTools.annotations.active = false
      state.mapTools.attributesTable.active = false
      state.mapTools.locator.active = false
      state.mapTools.draw.active = false
    },
    // Desactiva todas las herramientas EXCEPTO la selección de puntos
    resetMapToolsSelectionExceptSelect(state) {
      state.mapTools.measures.active = false
      state.mapTools.chart.active = false
      state.mapTools.magnify.active = false
      state.mapTools.layers.active = false
      state.mapTools.search.active = false
      state.mapTools.geoprocessing.active = false
      state.mapTools.export.active = false
      state.mapTools.basemap.active = false
      state.mapTools.shpKmzUpload.active = false
      state.mapTools.annotations.active = false
      state.mapTools.attributesTable.active = false
      state.mapTools.locator.active = false
      state.mapTools.draw.active = false
      // state.mapTools.select is intentionally NOT reset here
      // state.mapTools.help is intentionally NOT reset here (panel concurrente con otras herramientas)
    },
    // Selecciona una herramienta del mapa
    setMapToolSelection(state, payload) {
      console.log("Se recepciona setMapToolSelection", payload)
      state.mapTools[payload.tool].active = payload.active
    },
    // Elimina cualquier acción realizada por la herramienta
    resetMapToolsAction(state) {
      state.mapTools.select.action = ''
      state.mapTools.measures.action = ''
      state.mapTools.chart.action = ''
      state.mapTools.magnify.action = ''
      state.mapTools.layers.action = ''
      state.mapTools.search.action = ''
      state.mapTools.geoprocessing.action = ''
      state.mapTools.export.action = ''
      state.mapTools.basemap.action = ''
      state.mapTools.shpKmzUpload.action = ''
      state.mapTools.help.action = ''
      state.mapTools.annotations.action = ''
      state.mapTools.attributesTable.action = ''
      state.mapTools.locator.action = ''
    },
    // Ejecuta una acción en una herramienta del mapa
    setMapToolAction(state, payload) {
      console.log("payload data", payload.data)
      console.log("State", state)
      console.log("Action", payload.action)
      state.mapTools[payload.tool].action = payload.action
      state.mapTools[payload.tool].data = payload.data
    },
    // Establece la lista de capas disponibles para el usuario
    setLayers(state, layers) {
      state.layers = layers
    },
    // Agrega una nueva capa a la lista de capas seleccionadas por el usuario para visualizarse en el mapa
    addActiveLayer(state, layer) {
      if (!state.activeLayers.find(l => l.id === layer.id)) {
        state.activeLayers.push(layer)
        console.log('add layer to map', layer)
      } else {
        console.warn('⚠️ La capa ya está activa en el store:', layer.name);
      }
    },
    // Remueve una capa de la lista de capas seleccionadas por el usuario para visualizarse en el mapa
    removeActiveLayer(state, layer) {
      let index = state.activeLayers.findIndex(function (item) { return item.id == layer.id })
      if (index > -1) {
        state.activeLayers.splice(index, 1);
      }
    },
    // Establece la lista de geoprocesos disponibles para el usuario
    setGeoprocessings(state, geoprocessings) {
      state.geoprocessings = geoprocessings
    },
    // Selecciona un control del mapa
    setMapControlSelection(state, payload) {
      state.mapControls[payload.control].active = payload.active
    },
    cleanActiveLayers(state) {
      state.activeLayers = []
    }
  },
  actions: {
    // Desactiva todas las herramientas de mapa
    resetMapToolsSelection({ commit }) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('resetMapToolsSelection')
          resolve()
        }, 1) // Delay mínimo para asegurar que la siguiente acción se ejecute después de esta
      })
    },
    // Selecciona una herramienta en el mapa
    setMapToolSelection({ commit }, payload) {
      console.log("Se recepciona setMapToolSelection", payload)
      if (payload.tool == 'attributesTable' || payload.tool == 'help') {
        commit('setMapToolSelection', payload)
      }
      else {
        return new Promise((resolve) => {
          setTimeout(() => {
            // Reset all tools except Point Selection (preserves select state across tool switches)
            commit('resetMapToolsSelectionExceptSelect')
            commit('setMapToolSelection', payload)
            resolve()
          }, 1)
        })
      }
    },
    // Elimina todas las acciones ejecutadas anteriormente
    resetMapToolsAction({ commit }) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('resetMapToolsAction')
          resolve()
        }, 1) // Delay mínimo para asegurar que la siguiente acción se ejecute después de esta
      })
    },
    // Ejecuta una acción en una herramienta
    setMapToolAction({ dispatch, commit }, payload) {
      return dispatch('resetMapToolsAction').then(() => {
        commit('setMapToolAction', payload)
      })
    },
    // Establece la lista de capas disponibles para el usuario
    setLayers(context, layers) {
      context.commit('setLayers', layers)
    },
    // Agrega una nueva capa a la lista de capas seleccionadas por el usuario
    addActiveLayer(context, layer) {
      context.commit('addActiveLayer', layer)
    },
    // Elimina una capa de la lista de capas seleccionadas por el usuario
    removeActiveLayer(context, layer) {
      context.commit('removeActiveLayer', layer)
    },
    // Establece la lista de geoprocesos disponibles para el usuario
    setGeoprocessings(context, geoprocessings) {
      context.commit('setGeoprocessings', geoprocessings)
    },
    // Selecciona un control del mapa
    setMapControlSelection(context, payload) {
      context.commit('setMapControlSelection', payload)
    },
    // Reiniciar el estado del mapa
    resetMap(context) {
      context.commit('resetMapToolsSelection')
      context.commit('resetMapToolsAction')
    },
    // Selecciona un control del mapa
    cleanActiveLayers(context) {
      context.commit('cleanActiveLayers')
    },
  }
})
